import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f7ac1032"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form" }
const _hoisted_2 = { class: "form__parts" }
const _hoisted_3 = { class: "form__parts" }
const _hoisted_4 = { class: "sform__button-wrapper" }
const _hoisted_5 = { class: "password-edit__modal" }
const _hoisted_6 = { class: "password-edit__modal-icon" }
const _hoisted_7 = { class: "password-edit__modal-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AHeading = _resolveComponent("AHeading")!
  const _component_ALabel = _resolveComponent("ALabel")!
  const _component_ABody = _resolveComponent("ABody")!
  const _component_AInput = _resolveComponent("AInput")!
  const _component_AButton = _resolveComponent("AButton")!
  const _component_CompleteCheckIcon = _resolveComponent("CompleteCheckIcon")!
  const _component_AModal = _resolveComponent("AModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AHeading, { level: 1 }, {
      default: _withCtx(() => [
        _createTextVNode("パスワード再設定")
      ], undefined, true),
      _: 1
    }),
    _createElementVNode("form", {
      class: "form__container",
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.passwordEdit()), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_ALabel, {
          class: "form__label",
          for: "password"
        }, {
          default: _withCtx(() => [
            _createTextVNode("パスワード")
          ], undefined, true),
          _: 1
        }),
        _createVNode(_component_ABody, {
          class: "form__body",
          size: "small"
        }, {
          default: _withCtx(() => [
            _createTextVNode("8文字以上の半角英数字記号")
          ], undefined, true),
          _: 1
        }),
        _createVNode(_component_AInput, {
          class: "form__input",
          type: "password",
          name: "password",
          value: _ctx.password,
          placeholder: "************",
          "validate-rule": _ctx.passwordValidateRule,
          "validate-mode": "blur",
          onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleInput($event, 'password')))
        }, null, 8, ["value", "validate-rule"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ALabel, {
          class: "form__label",
          for: "password"
        }, {
          default: _withCtx(() => [
            _createTextVNode("パスワードの再入力")
          ], undefined, true),
          _: 1
        }),
        _createVNode(_component_AInput, {
          class: "form__input",
          type: "password",
          name: "password_confirmation",
          value: _ctx.passwordConfirmation,
          "match-value": _ctx.password,
          placeholder: "確認のためにもう一度入力してください",
          "validate-rule": _ctx.passwordValidateRule,
          "validate-mode": "blur",
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleInput($event, 'password_confirmation')))
        }, null, 8, ["value", "match-value", "validate-rule"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_AButton, {
          round: "",
          fill: "",
          bold: "",
          size: "medium",
          disabled: _ctx.disabled,
          processing: _ctx.processing,
          class: "form__button"
        }, {
          default: _withCtx(() => [
            _createTextVNode("パスワード再設定を完了する")
          ], undefined, true),
          _: 1
        }, 8, ["disabled", "processing"])
      ])
    ], 32),
    (_ctx.showModal)
      ? (_openBlock(), _createBlock(_component_AModal, { key: 0 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_CompleteCheckIcon)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_ABody, null, {
                  default: _withCtx(() => [
                    _createTextVNode("パスワード再設定が完了しました！")
                  ], undefined, true),
                  _: 1
                })
              ])
            ])
          ], undefined, true),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}